export default "__VITE_ASSET__ByFtLnU3__"